import { mapGismeteoPrecipitationSlice } from "./MapGismeteoPrecipitationSlice"
import { mapPathSlice } from "./MapPathSlice"
import { mapRoadWorksSlice } from "./MapRoadWorksSlice"
import { mapRoadWorksWithNormativitiesSlice } from "./MapRoadWorksWithNormativitiesSlice"
import { mapWaysideLandLotsSlice } from "./MapWaysideLandLotsSlice"

export const mapActions = {
    roadWorks: mapRoadWorksSlice.actions,
    roadWorksWithNormativities: mapRoadWorksWithNormativitiesSlice.actions,
    path: mapPathSlice.actions,
    gismeteoPrecipitation: mapGismeteoPrecipitationSlice.actions,
    waysideLandLots: mapWaysideLandLotsSlice.actions
}

export type MapName = keyof typeof mapActions